import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import PageCard from '../components/PageCard';
import Tradition from '../components/Tradition';
import Game from '../components/Game';
import Experience from '../components/Experience';
import Evenement from '../components/Evenement';
import Partenaire from '../components/Partenaires';
import FlipCard from '../components/FlipCard';
import FooterPage from '../components/FooterPage';

const MultiShop: React.FC = () => {
  const topRef = useRef<HTMLDivElement>(null)

  useEffect(() =>{
    if(topRef){
      window.scrollTo(0,0)
    }
  },[])

  return(
    <div ref={topRef}>
      <PageCard/>
      <Tradition/>
      <Game/>
      <Experience/>
      <Evenement/>
      <Partenaire/>
      <FlipCard/>
      <FooterPage/>
    </div>
  )

}
;

export default MultiShop;
